import React from "react";
import user from "../../img/figure/user.jpg";
import user1 from "../../img/figure/user1.jpg";
import user2 from "../../img/figure/user2.jpg";
import user3 from "../../img/figure/user3.jpg";
import user4 from "../../img/figure/user4.jpg";
import user5 from "../../img/figure/user5.jpg";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import CustomInput from "../../Shared/CustomInput";
import {
  classOptions,
  genderOptions,
  religionOption,
  subjectOptions,
  userOption,
} from "../../utils/helpers";
import CustomSelect from "../../Shared/CustomSelect";
import { date } from "yup";
import SubmitForm from "../../Shared/SubmitForm";
const AccountSettings = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    console.log("submitting data ", data);
  };
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Account Setting</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Setting</li>
        </ul>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Add New User</h3>
                </div>
                <Cta />
              </div>
              <form
                className="new-added-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row">
                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"First Name *"}
                      register={register}
                      errors={errors}
                      name={"firstname"}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Last Name *"}
                      register={register}
                      errors={errors}
                      name={"lastname"}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"User Type *"}
                      register={register}
                      errors={errors}
                      name={"gender"}
                      placeholder={"Please select"}
                      option={userOption}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Gender *"}
                      register={register}
                      errors={errors}
                      name={"gender"}
                      placeholder={"Select Subject"}
                      option={genderOptions}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Father Name *"}
                      register={register}
                      errors={errors}
                      name={"fathername"}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Mother Name *"}
                      register={register}
                      errors={errors}
                      name={"mothername"}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Date Of Birth *"}
                      register={register}
                      type={date}
                      errors={errors}
                      name={"firstname"}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Religion Type *"}
                      register={register}
                      errors={errors}
                      name={"religion"}
                      placeholder={"Please Select"}
                      option={religionOption}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Joining Date *"}
                      register={register}
                      errors={errors}
                      type={date}
                      name={"firstname"}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Email *"}
                      register={register}
                      errors={errors}
                      name={"email"}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Subject *"}
                      register={register}
                      errors={errors}
                      name={"subject"}
                      placeholder={"Please Select"}
                      option={subjectOptions}
                    />
                  </div>

                  <div className="col-xl-3 col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Class *"}
                      register={register}
                      errors={errors}
                      name={"class"}
                      placeholder={"Please Select"}
                      option={classOptions}
                    />
                  </div>

                  <div className="col-lg-6 col-12 form-group">
                    <label>Address *</label>
                    <textarea
                      className="textarea form-control"
                      rows="4"
                      {...register("address", {
                        required: "Address is required",
                      })}
                    ></textarea>
                    {errors.address && (
                      <p style={{ color: "red" }}>{errors.address.message}</p>
                    )}
                  </div>

                  <SubmitForm />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-4-xxxl col-xl-5">
          <div class="card account-settings-box height-auto">
            <div class="card-body">
              <div class="heading-layout1 mg-b-20">
                <div class="item-title">
                  <h3>All User</h3>
                </div>
                <Cta />
              </div>
              <div class="all-user-box">
                <div class="media media-none--xs active">
                  <div class="item-img">
                    <img src={user1} class="media-img-auto" alt="user" />
                  </div>
                  <div class="media-body space-md">
                    <h5 class="item-title">Steven Johnson</h5>
                    <div class="item-subtitle">Super Admin</div>
                  </div>
                </div>
                <div class="media media-none--xs">
                  <div class="item-img">
                    <img src={user2} class="media-img-auto" alt="user" />
                  </div>
                  <div class="media-body space-md">
                    <h5 class="item-title">Maria Jane</h5>
                    <div class="item-subtitle">Super Admin</div>
                  </div>
                </div>
                <div class="media media-none--xs">
                  <div class="item-img">
                    <img src={user3} class="media-img-auto" alt="user" />
                  </div>
                  <div class="media-body space-md">
                    <h5 class="item-title">Andrew Walles</h5>
                    <div class="item-subtitle">Super Admin</div>
                  </div>
                </div>
                <div class="media media-none--xs">
                  <div class="item-img">
                    <img src={user4} class="media-img-auto" alt="user" />
                  </div>
                  <div class="media-body space-md">
                    <h5 class="item-title">Walter Emma</h5>
                    <div class="item-subtitle">Super Admin</div>
                  </div>
                </div>
                <div class="media media-none--xs">
                  <div class="item-img">
                    <img src={user5} class="media-img-auto" alt="user" />
                  </div>
                  <div class="media-body space-md">
                    <h5 class="item-title">Stuart Johnson</h5>
                    <div class="item-subtitle">Super Admin</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8-xxxl col-xl-7">
          <div class="card account-settings-box">
            <div class="card-body">
              <div class="heading-layout1 mg-b-20">
                <div class="item-title">
                  <h3>User Details</h3>
                </div>
                <Cta />
              </div>
              <div class="user-details-box">
                <div class="item-img">
                  <img src={user} alt="user" />
                </div>
                <div class="item-content">
                  <div class="info-table table-responsive">
                    <table class="table text-nowrap">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td class="font-medium text-dark-medium">
                            Steven Johnson
                          </td>
                        </tr>
                        <tr>
                          <td>User Type:</td>
                          <td class="font-medium text-dark-medium">
                            Super Admin
                          </td>
                        </tr>
                        <tr>
                          <td>Gender:</td>
                          <td class="font-medium text-dark-medium">Male</td>
                        </tr>
                        <tr>
                          <td>Father Name:</td>
                          <td class="font-medium text-dark-medium">
                            Steve Jones
                          </td>
                        </tr>
                        <tr>
                          <td>Mother Name:</td>
                          <td class="font-medium text-dark-medium">
                            Naomi Rose
                          </td>
                        </tr>
                        <tr>
                          <td>Date Of Birth:</td>
                          <td class="font-medium text-dark-medium">
                            07.08.2016
                          </td>
                        </tr>
                        <tr>
                          <td>Religion:</td>
                          <td class="font-medium text-dark-medium">Islam</td>
                        </tr>
                        <tr>
                          <td>Joining Date:</td>
                          <td class="font-medium text-dark-medium">
                            07.08.2016
                          </td>
                        </tr>
                        <tr>
                          <td>E-mail:</td>
                          <td class="font-medium text-dark-medium">
                            stevenjohnson@gmail.com
                          </td>
                        </tr>
                        <tr>
                          <td>Subject:</td>
                          <td class="font-medium text-dark-medium">English</td>
                        </tr>
                        <tr>
                          <td>Class:</td>
                          <td class="font-medium text-dark-medium">2</td>
                        </tr>
                        <tr>
                          <td>Section:</td>
                          <td class="font-medium text-dark-medium">Pink</td>
                        </tr>
                        <tr>
                          <td>ID No:</td>
                          <td class="font-medium text-dark-medium">10005</td>
                        </tr>
                        <tr>
                          <td>Address:</td>
                          <td class="font-medium text-dark-medium">
                            House #10, Road #6, Australia
                          </td>
                        </tr>
                        <tr>
                          <td>Phone:</td>
                          <td class="font-medium text-dark-medium">
                            + 88 98568888418
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSettings;
